export default __webpack_public_path__ + "static/media/5438645.69ec5ddc.jpg";